import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

// HP3-only — full-bleed "Analyze Your Skin" skin-tools band. Uses the supplied
// face-zones image (no baked-in copy); copy + CTA overlaid on the dark right
// side. Content reveals bottom-to-top on scroll into view.
const BG =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_e3513a08-18b3-459d-901e-2457595c9150/artifacts/7voa74pu_riversol_face_zones_extended_1920x816.png";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

const scrollToFinder = () => {
  const el = document.querySelector('[data-testid="home-quick-finder"]');
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const AnalyzeSkinV3 = () => {
  return (
    <section
      className="relative w-full overflow-hidden bg-[#2a2a2c]"
      data-testid="home-analyze-skin-v3"
    >
      <img
        src={BG}
        alt="Facial skin zone analysis"
        className="absolute inset-0 w-full h-full object-cover object-left"
        draggable={false}
      />
      {/* Right-side legibility wash for smaller viewports */}
      <div className="absolute inset-0 bg-gradient-to-l from-black/45 via-transparent to-transparent lg:hidden" />

      <div className="relative max-w-[1800px] mx-auto px-6 lg:px-12">
        <div className="min-h-[440px] lg:min-h-[620px] flex items-center justify-end">
          <motion.div
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-120px" }}
            className="w-full max-w-[300px] lg:max-w-[460px] text-white py-16"
          >
            <motion.div
              variants={item}
              className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/60"
            >
              Skin Tools
            </motion.div>
            <motion.h2
              variants={item}
              className="mt-5 text-[38px] lg:text-[56px] leading-[1.02] tracking-[-0.02em] font-semibold"
            >
              Analyze Your Skin.
            </motion.h2>
            <motion.p
              variants={item}
              className="mt-5 text-[15px] lg:text-[16px] leading-[1.6] text-white/75 max-w-[420px]"
            >
              Build a personalized skincare routine in minutes. Answer a few
              questions to get tailored product recommendations guided by
              dermatologist expertise and insights from 15 million facial photos.
            </motion.p>
            <motion.div variants={item}>
              <button
                type="button"
                onClick={scrollToFinder}
                data-testid="analyze-skin-cta"
                className="mt-9 inline-flex items-center gap-2 bg-white text-neutral-900 px-8 py-4 text-[12px] tracking-[0.14em] uppercase font-semibold hover:bg-white/90 transition-colors"
              >
                Start Analysis
                <ArrowRight size={15} strokeWidth={2} />
              </button>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AnalyzeSkinV3;
